import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { useModal } from "@/modals"
import { Modal } from "@/ui/Modal"
import { IModalCenter } from "."
import styles from "./ModalCenter.module.scss"

export const ModalCenter: FC<PropsWithChildren<IModalCenter>> = ({
  children,
  onClose,

  ...props
}) => {
  const {
    type,
    className,
    bodyWrap,
    body,
    isCanClose = true,
    ...restProps
  } = props

  const { modal } = useModal(type)

  const handleClose = () => {
    if (!isCanClose) return

    onClose?.()
    modal.close()
  }

  return (
    <Modal.Wrapper {...props}>
      <div className={clsx(styles.Modal, className)} {...restProps}>
        <div className={clsx(styles.Modal_back)} onClick={handleClose} />
        <div
          {...bodyWrap}
          className={clsx(styles.Modal_bodyWrap, bodyWrap?.className)}
        >
          <div {...body} className={clsx(styles.Modal_body, body?.className)}>
            {children}
          </div>
        </div>
      </div>
    </Modal.Wrapper>
  )
}
